import { SUPPORT_EMAIL } from "@/frontend/constants/support";

/** Builds a `mailto:` link to the support inbox with `subject` prefilled. */
export function supportMailto(subject: string): string {
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
}
